<template>
  <!-- postmanage add -->
      <!-- v-bind="this.$store.state.modalConfig" -->
  <div>
    <a-modal
      title="编辑"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      maskClosable=false,
      keyboard=false,
      destroyOnClose=true,
      centered=true,
      width='600px'
    >
      <a-form :form="form" v-bind="itemLayout || $store.state.base_itemLayout">
        <a-form-item
         label="设为置顶"
         v-bind="$store.state.modal_ItemLayout"
        >
            <a-switch  :checked="isChecked_top"  @change="switchClick($event,'top')"/>
          </a-form-item>
      </a-form>
      <a-form :form="form" v-bind="itemLayout || $store.state.base_itemLayout">
        <a-form-item
         label="设为推荐"
         v-bind="$store.state.modal_ItemLayout"
        >
            <a-switch  :checked="isChecked_recommemd"  @change="switchClick($event,'recommemd')"/>
          </a-form-item>
      </a-form>
      <a-form :form="form" v-bind="itemLayout || $store.state.base_itemLayout">
        <a-form-item
         label="排序"
         v-bind="$store.state.modal_ItemLayout"
        >
          <a-input type = 'number' v-model="sort"
            v-decorator="[
          'sort',
          { rules: [{ required: true, message: '请输入排序' },
          { max: 5, message: '最多5位数' },
          { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger },
          ] },
        ]"
          />
          </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'postmanageAdd',
  components: { },
  data () {
    return {
      initReqHandle: false,
      isChecked_top: false,
      isChecked_recommemd: false,
      sort: undefined,
      circleId: undefined,
      visible: false,
      lngLat: [],
      position: '',
      form: this.$form.createForm(this, { name: 'dynamic_rule' })

    };
  },
  created () {
  },
  methods: {
    okFun () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.$put({
          url: '/housekeep/circles/' + this.circleId,
          params: {
            top: this.isChecked_top ? 1 : 0,
            recommend: this.isChecked_recommemd ? 1 : 0,
            sort: this.sort
          }
        }).then((res) => {
          this.$message.success(res.msg);
          this.$emit('updateTable', res);
          this.closeFun();
        });
      });
    },
    switchClick (e, handle) {
      let attr = 'isChecked_' + handle;
      this[attr] = e;
    },
    closeFun () {
      this.visible = false;
      this.formList[0].fileList = [];
    },
    show (row) {
      this.circleId = row.circleId;
      this.sort = row.sort;
      this.isChecked_top = row.top == 1;
      this.isChecked_recommemd = row.recommend == 1;

      setTimeout(() => {
        this.visible = true;
      }, 100);
      setTimeout(() => {
        this.form.setFieldsValue({sort: row.sort.toString()});
      }, 150);
    }
  }
};
</script>
<style lang="less" scoped>
</style>
